import React, { useState, useEffect } from 'react'
import { connect } from 'react-redux'
import { GATED_BIBLIOGRAPHY_ON_EXPIRATION_MODAL } from '@chegg-wt/core/state/modals/constants'
import { useRoutesContext } from '@chegg-wt/core/components/RoutesContext'
import { AppState } from '@chegg-wt/core/state'
import { modalDataSelector } from '@chegg-wt/core/state/modals/selectors'
import { navigated } from '@chegg-wt/core/state/app/actions'
import { GatedBibliographyOnExpirationModalData } from '@chegg-wt/core/state/bibliography/types'
import { Config } from '@chegg-wt/core/config'
import { CITATION_LIST_NAME_LOWER_SINGLE } from '@chegg-wt/core/constants/citations'
import {
  emitComponentViewEvent,
  userClick,
} from '@chegg-wt/core/state/instrumentation/actions'
import { componentOrigins } from '@chegg-wt/core/state/instrumentation/rio/clickstreamComponentViews'
import { origins } from '@chegg-wt/core/state/instrumentation/rio/clickstreamInteractions'
import BaseGatedBibliographyModal from '../BaseGatedBibliographyModal'
import { GatedBibliographyOnExpirationModalProps } from './types'

export const GatedBibliographyOnExpirationModal: React.FC<GatedBibliographyOnExpirationModalProps> = ({
  data,
  navigated,
  folderPageExpirationModalRioEvent,
  bibPageExpirationModalRioEvent,
  foldersPageExpirationUpgradeCTA,
  bibPageExpirationContinueCTA,
  bibPageExpirationUpgradeCTA,
}) => {
  const { toFolders, toUpgrade } = useRoutesContext()
  const [isRioSent, setIsRioSent] = useState<boolean>(false)
  const { isDismissible, shouldContinueToFolders } = data

  const message = `This ${CITATION_LIST_NAME_LOWER_SINGLE} has expired. To access it, upgrade to a ${Config.siteName} Premium account.`
  const header = `View ${CITATION_LIST_NAME_LOWER_SINGLE}`

  useEffect(() => {
    if (!isRioSent) {
      if (shouldContinueToFolders) {
        bibPageExpirationModalRioEvent(header)
      } else {
        folderPageExpirationModalRioEvent(header)
      }
      setIsRioSent(true)
    }
  }, [isRioSent, shouldContinueToFolders])

  const onUpgrade = (text: string) => {
    if (shouldContinueToFolders) {
      bibPageExpirationUpgradeCTA(text)
    } else {
      foldersPageExpirationUpgradeCTA(text)
    }
    navigated(toUpgrade())
  }
  const onContinue = shouldContinueToFolders
    ? (text: string) => {
        bibPageExpirationContinueCTA(text)
        navigated(toFolders())
      }
    : null

  return (
    <BaseGatedBibliographyModal
      modalName={GATED_BIBLIOGRAPHY_ON_EXPIRATION_MODAL}
      header={header}
      message={message}
      isDismissible={isDismissible}
      onContinue={onContinue}
      onUpgrade={onUpgrade}
    />
  )
}

const mapStateToProps = (state: AppState) => ({
  data: modalDataSelector(state) as GatedBibliographyOnExpirationModalData,
})

const mapDispatchToProps = {
  navigated,
  folderPageExpirationModalRioEvent: (text: string) =>
    emitComponentViewEvent({
      origin: componentOrigins.foldersPageExpiration,
      text,
    }),
  bibPageExpirationModalRioEvent: (text: string) =>
    emitComponentViewEvent({
      origin: componentOrigins.bibPageExpiration,
      text,
    }),
  foldersPageExpirationUpgradeCTA: (text: string) =>
    userClick({ origin: origins.foldersPageExpirationUpgradeCTA, text }),
  bibPageExpirationContinueCTA: (text: string) =>
    userClick({ origin: origins.bibPageExpirationContinueCTA, text }),
  bibPageExpirationUpgradeCTA: (text: string) =>
    userClick({ origin: origins.bibPageExpirationUpgradeCTA, text }),
}

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(GatedBibliographyOnExpirationModal)
